// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px;
  padding-bottom: 60px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
  border: 1px solid var(--color-black);
  border-radius: 16px;
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
}
.wrapper .title {
  font-family: AppFontMedium, sans-serif;
  width: 100%;
  font-size: 22px;
  text-transform: uppercase;
  color: var(--color-black);
  text-align: start;
  padding: 20px 0px 10px;
  text-transform: uppercase;
  text-align: center;
}
.wrapper .description {
  font-family: AppFont;
  font-size: 14px;
  color: var(--color-black);
  padding: 5px 0px 10px;
  text-align: center;
}
.wrapper ion-col .card-item {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  border-radius: var(--custom-border-radius);
  transition: border 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.wrapper ion-col .card-item.selected {
  background: rgba(216, 11, 49, 0.3568627451);
  border: 2px solid var(--color-black);
  background: #F6FAF6;
}
.wrapper ion-col .card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper ion-col .card-item .image-block {
  width: 100%;
  position: relative;
  margin-bottom: 8px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  aspect-ratio: 512/371;
  object-fit: contain;
}
.wrapper ion-col .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.wrapper ion-col .card-item .info-block .name {
  height: 38px;
  font-family: AppFontMedium, sans-serif;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: var(--color-black);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 992px) {
  .wrapper ion-col .card-item .info-block .name {
    font-size: 13px;
    height: 32px;
    overflow: hidden;
  }
}
.wrapper ion-col .card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: #000000;
  margin: 0;
  margin-top: 20px;
  text-align: center;
}

.price {
  margin: 8px 0 0;
  font-weight: 600;
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
  text-align: right;
  font-size: 16px;
  width: 90%;
}

.content_block {
  height: calc(100% - 124px);
  overflow-y: auto;
  width: 100%;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.footer-btn ion-button {
  margin: 5px 0px;
  width: 90%;
  text-transform: uppercase;
  color: #fff;
  font-size: 16px;
  font-size: 15px;
  min-height: 36px;
}
.footer-btn ion-button.cancel-btn {
  --background: transparent;
  color: var(--color-black);
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: var(--color-black);
  text-align: left;
  padding-top: 6px;
}

.add-button {
  width: 100%;
  margin-top: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-black);
  border-radius: 8px;
  cursor: pointer;
}
.add-button p {
  font-family: AppFontMedium;
  color: var(--color-black);
  font-size: 14px;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  color: var(--color-black);
  font-size: 20px;
  font-family: AppFont;
}
.quantity-selector .quantity-btn {
  width: 30px;
  height: 30px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.selected_item_icon {
  position: absolute;
  top: 5px;
  left: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.selected_item_icon.active {
  z-index: 99;
  opacity: 1;
}

.footer-section {
  padding: 5px 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;EACA,oCAAA;EACA,mBAAA;AADD;AAEC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAAF;AACE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AACH;AAEC;EACC,kBAAA;EACA,WAAA;AAAF;AAEC;EACC,sCAAA;EACA,WAAA;EACA,eAAA;EAEA,yBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAFF;AAIC;EACC,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAFF;AAKE;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EAEA,0CAAA;EAGA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AANH;AAOG;EAEE,2CAAA;EACA,oCAAA;EACA,mBAAA;AANL;AASG;EACC,YAAA;EACA,8BAAA;EACA,sBAAA;AAPJ;AAUG;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;AARJ;AAcI;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAZL;AAcI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAZL;AAgBG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAdJ;AAeI;EACC,YAAA;EACA,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAdL;AChHE;ED8GE;IAmBE,eAAA;IACA,YAAA;IACA,gBAAA;EAbJ;AACF;AAeI;EACC,cAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAbL;;AAoBA;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sCAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;AAjBD;;AAmBA;EACC,0BAAA;EACA,gBAAA;EACA,WAAA;AAhBD;;AAkBA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAfD;AAgBC;EACC,eAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EAKA,eAAA;EACA,gBAAA;AAlBF;AAaE;EACC,yBAAA;EACA,yBAAA;AAXH;;AAiBA;EACC,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAdD;;AAiBA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AAdJ;AAgBI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAdN;;AAkBE;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EAKA,YAAA;AAnBD;AAeC;EACE,eAAA;EACA,eAAA;AAbH;AAgBC;EACE,yBAAA;EACA,eAAA;EACA,oBAAA;AAdH;AAgBC;EACE,WAAA;EACA,YAAA;AAdH;AAeG;EACD,YAAA;AAbF;;AAkBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;AAfJ;AAiBI;EACE,WAAA;EACA,UAAA;AAfN;;AAkBE;EACD,qBAAA;AAfD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 20px;\n\tpadding-bottom: 60px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: var(--background-default);\n\tborder: 1px solid var(--color-black);\n\tborder-radius: 16px;\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n\t.header-wrapper {\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t}\n\t.title {\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\twidth: 100%;\n\t\tfont-size: 22px;\n\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--color-black);\n\n\t\ttext-align: start;\n\t\tpadding: 20px 0px 10px;\n\t\ttext-transform: uppercase;\n\t\ttext-align: center;\n\t}\n\t.description {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tcolor: var(--color-black);\n\t\tpadding: 5px 0px 10px;\n\t\ttext-align: center;\n\t}\n\tion-col {\n\t\t.card-item {\n\t\t\tposition: relative;\n\t\t\tmargin: 0 auto;\n\t\t\tflex-grow: 1;\n\t\t\tmin-height: 100%;\n\t\t\tword-break: break-word;\n\t\t\tbackground: white;\n\t\t\tborder: 2px solid white;\n\t\t  \n\t\t\tborder-radius: var(--custom-border-radius);\n\n\t\t  \n\t\t\ttransition: border 200ms linear;\n\t\t\ttext-align: center;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\t&.selected {\n\t\t  \n\t\t\t  background: #d80b315b;\n\t\t\t  border: 2px solid var(--color-black);\n\t\t\t  background: #F6FAF6;\n\t\t\t}\n\n\t\t\t.default-img {\n\t\t\t\tpadding: 5px;\n\t\t\t\tobject-fit: contain !important;\n\t\t\t\tbackground-color: #fff;\n\t\t\t}\n\n\t\t\t.image-block {\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-bottom: 8px;\n\n\t\t\t\t// &:has(.default_img) {\n\t\t\t\t// \tbackground-color: var(--ion-color-primary);\n\t\t\t\t// }\n\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\taspect-ratio: 512 / 371;\n\t\t\t\t\tobject-fit: contain;\n\t\t\t\t}\n\t\t\t\t.plus {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\tright: 10px;\n\t\t\t\t\theight: 32px;\n\t\t\t\t\twidth: 32px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tflex-grow: 1;\n\t\t\t\t.name {\n\t\t\t\t\theight: 38px;\n\t\t\t\t\tfont-family: AppFontMedium,sans-serif;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--color-black);\n\t\t\t\t\tword-break: break-word;\n\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\n\t\t\t\t\t@include mobile {\n\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.deposit_text {\n\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\tcolor: #000000;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\n\t\t\t}\n\t\t}\n\t}\n}\n.price {\n\tmargin: 8px 0 0;\n\tfont-weight: 600;\n\tcolor: var(--color-black);\n\tfont-family: AppFontMedium, sans-serif;\n\ttext-align: right;\n\tfont-size: 16px;\n\twidth: 90%;\n}\n.content_block {\n\theight: calc(100% - 124px);\n\toverflow-y: auto;\n\twidth: 100%;\n}\n.footer-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tleft: 0px;\n\tright: 0px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\tion-button {\n\t\tmargin: 5px 0px;\n\t\twidth: 90%;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\tfont-size: 16px;\n\t\t&.cancel-btn {\n\t\t\t--background: transparent;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t\tfont-size: 15px;\n\t\tmin-height: 36px;\n\t}\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: var(--color-black);\n\ttext-align: left;\n\tpadding-top: 6px;\n}\n\n.add-button {\n    width: 100%;\n    margin-top: 10px;\n    padding: 5px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--color-black);\n    border-radius: 8px;\n    cursor: pointer;\n\n    p {\n      font-family: AppFontMedium;\n      color:var(--color-black);\n      font-size: 14px;\n    }\n\n  }\n  .quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tion-icon {\n\t  margin: 0px 6px;\n\t  cursor: pointer;\n\t}\n\tz-index:  999;\n\t.quantity {\n\t  color:var(--color-black);\n\t  font-size: 20px;\n\t  font-family: AppFont;\n\t}\n\t.quantity-btn {\n\t  width: 30px;\n\t  height: 30px;\n\t  &.add-opacity {\n\t\topacity: 0.5;\n\t}\n\t}\n  }\n \n  .selected_item_icon {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    \n    &.active {\n      z-index: 99;\n      opacity: 1;\n    }\n  }\n  .footer-section {\n\tpadding: 5px 0px 10px;\n  }","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
